import { getTimestampFromDateString, getStartOfQuarterTimestamp } from "common/date-utils";
import { getPrincipleNumber, getPrincipleSource, getPrincipleStatus, principlesIndexes, ViolationType } from "common/un-principles-helper";
import { language } from "language/default";
const principlesWidgetLang = language.en.widgets.principlesTable;
const getExtremities = (array) => ({ end: array[array.length - 1], start: array[0] });
const sortIndexes = (indexes) => {
    indexes.sort((a, b) => a - b);
    return indexes;
};
const getRanges = (indexes) => {
    const current = [], ranges = [];
    for (const index of sortIndexes(indexes)) {
        if (current.length === 0 || current[current.length - 1] + 1 < index) {
            if (current.length) {
                ranges.push(getExtremities(current));
            }
            current.length = 0;
        }
        current.push(index);
    }
    if (current.length) {
        ranges.push(getExtremities(current));
    }
    return ranges;
};
const pushViolation = (violationsMap, source, number, index) => {
    if (!violationsMap.has(`${source}${number}`)) {
        violationsMap.set(`${source}${number}`, { indexes: [], principle: number, source });
    }
    violationsMap.get(`${source}${number}`)?.indexes.push(index);
};
const groupViolations = (data) => {
    const sorted = [...data], violations = {
        [ViolationType.NoViolation]: new Map(),
        [ViolationType.Potential]: new Map(),
        [ViolationType.Violation]: new Map()
    };
    sorted.sort((a, b) => (a.ReferenceDate && b.ReferenceDate && a.ReferenceDate > b.ReferenceDate ? 1 : -1));
    for (const [index, entry] of sorted.entries()) {
        for (const [principle, value] of Object.entries(entry)) {
            const number = getPrincipleNumber(principle);
            if (number) {
                const source = getPrincipleSource(value) || "", status = getPrincipleStatus(value);
                pushViolation(violations[status], source, number, index);
            }
        }
    }
    return { sorted, violations };
};
const getYValue = (principle) => {
    const indexes = [principlesIndexes.environmentEndIndex, principlesIndexes.humanRightsEndIndex, principlesIndexes.labourEndIndex];
    const increment = indexes.filter((i) => principle > i).length;
    return principle + increment;
};
const addPrinciple = (categories, y, principle) => {
    const groupsOverlay = {
        first: 0,
        fourth: 12,
        second: 3,
        third: 8
    };
    if (y >= 0 && !categories[y]) {
        categories[groupsOverlay.first] = "";
        categories[groupsOverlay.second] = "";
        categories[groupsOverlay.third] = "";
        categories[groupsOverlay.fourth] = "";
        categories[y] = `${principlesWidgetLang.principle} ${principle}`;
    }
};
const getGroups = () => {
    const preceededBy = {
        oneCategory: 1,
        threeCategories: 3,
        twoCategories: 2
    };
    const remainingCategoriesAndPrinciples = 2;
    const groups = new Array(principlesIndexes.environmentEndIndex + preceededBy.threeCategories + remainingCategoriesAndPrinciples);
    groups.fill("");
    groups[0] = principlesWidgetLang.humanRights;
    groups[principlesIndexes.environmentEndIndex + preceededBy.threeCategories] = principlesWidgetLang.antiCorruption;
    groups[principlesIndexes.humanRightsEndIndex + preceededBy.oneCategory] = principlesWidgetLang.labour;
    groups[principlesIndexes.labourEndIndex + preceededBy.twoCategories] = principlesWidgetLang.environment;
    return groups;
};
export const getUnPrinciplesValues = (series) => {
    const data = [], principles = [];
    if (series?.length) {
        const { violations, sorted } = groupViolations(series);
        for (const type of [ViolationType.Potential, ViolationType.Violation, ViolationType.NoViolation]) {
            for (const [, { indexes, source, principle: number }] of violations[type]) {
                const y = getYValue(number);
                addPrinciple(principles, y, number);
                for (const range of getRanges(indexes)) {
                    data.push({
                        custom: { source, type: ViolationType[type] },
                        x: getStartOfQuarterTimestamp(getTimestampFromDateString(sorted[range.start].ReferenceDate || "")),
                        x2: getTimestampFromDateString(sorted[range.end].ReferenceDate || ""),
                        y
                    });
                }
            }
        }
    }
    return { data, groups: getGroups(), principles: [...principles].map((g) => g) };
};
